module.exports = __webpack_public_path__ + "img/map.4d8f6e2f.jpg";